import { NotificationCenterMessageLanguage } from '../models/notification-center-message-language.model';

/**
 * Retrieves the message language associated with the supplied LCID
 * @param languages Array of languages associated with the notification
 * @param lcid LCID of the notification we want
 * @returns The language associated with the lcid supplied otherwise the first record if it has one. Otherwise undefined
 */
export function getMessageLanguageForLcid(
  languages: NotificationCenterMessageLanguage[],
  lcid: number
): NotificationCenterMessageLanguage | undefined {
  if (languages && lcid) {
    if (languages.some((ml) => ml.lcid === lcid)) {
      return languages.find((ml) => ml.lcid === lcid);
    } else {
      return languages[0];
    }
  }
  return undefined;
}
